export default "__VITE_ASSET__0d3ba586__"